import axios from "axios";

const API_BASE_URL = "https://royalapi.bizautotech.com/api";
//const API_BASE_URL = "http://localhost:5170/api";

// ✅ Create Axios Instance
const api = axios.create({
  baseURL: API_BASE_URL,
});

// ✅ Attach Token Automatically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ================= AUTH APIs =================

// 🔹 Register
export const registerUser = (data) => {
  return api.post("/Auth/register", data);
};

// 🔹 Login
export const loginUser = (data) => {
  return api.post("/Auth/login", data);
};

export default api;